<template>
  <footer class="w-full bg-primary text-white">
    <!-- Main Footer -->
    <div class="bg-center">
      <div class="container mx-auto px-4 py-12">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <!-- Brand Section -->
          <div class="space-y-4">
            <div class="flex items-center gap-4">
              <RouterLink :to="{ name: 'home' }">
                <img :src="logo" alt="UNAC Air France" class="h-16" />
              </RouterLink>
            </div>
            <p class="text-2xl font-light">
              Plus forts, <span class="font-bold">ensemble</span> !
            </p>

          </div>

          <!-- Quick Links -->
          <div class="space-y-4">
            <h3 class="text-lg font-semibold mb-4">Navigation</h3>
            <ul class="space-y-3">
              <li>
                <router-link :to="{ name: 'home' }"
                  class="text-white/70 hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                  Accueil
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'blog' }"
                  class="text-white/70 hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                  </svg>
                  Actualités
                </router-link>
              </li>
              <li>
                <template v-if="authStore.isAuthenticated">
                  <router-link :to="{ name: 'accords' }"
                    class="text-white/70 hover:text-white transition-colors duration-200 flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Accords
                  </router-link>
                </template>
                <template v-else>
                  <button @click="OpenModal = true"
                    class="text-white/70 hover:text-white transition-colors duration-200 flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Accords
                  </button>
                </template>
              </li>
              <li>
                <template v-if="!authStore.isAuthenticated">
                  <router-link :to="{ name: 'adhesion' }"
                    class="text-white/70 hover:text-white transition-colors duration-200 flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                    </svg>
                    Adhésion
                  </router-link>
                </template>
              </li>
            </ul>
          </div>

          <!-- Contact Section -->
          <div class="space-y-4">
            <h3 class="text-lg font-semibold mb-4">Contact</h3>
            <ul class="space-y-3">
              <li>
                <button class="text-white/70 hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <a :href="`mailto:${displayEmail}`">{{ displayEmail }}</a>
                </button>
              </li>
              <template v-for="(phone, index) in displayPhones" :key="`footer-phone-${index}`">
                <li class="text-white/70 flex items-center gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  <a :href="`tel:${phone.value}`">{{ phone.label }}: {{ phone.value }}</a>
                </li>
              </template>
              

              <li class="text-white/70 flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>
                  <template v-for="(line, index) in displayAddressLines" :key="`footer-address-${index}`">
                    {{ line }}<br v-if="index < displayAddressLines.length - 1" />
                  </template>
                </span>
              </li>
            </ul>
          </div>

          <!-- Legal Section -->
          <div class="space-y-4">
            <h3 class="text-lg font-semibold mb-4">Informations légales</h3>
            <ul class="space-y-3">
              <li>
                <RouterLink :to="{ name: 'legal-notice' }"
                  class="text-white/70 hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Mentions légales
                </RouterLink>
              </li>
              <li>
                <RouterLink :to="{ name: 'privacy-policy' }"
                  class="text-white/70 hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Politique de confidentialité
                </RouterLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- Copyright Bar -->
    <div class="bg-primary-dark py-4">
      <div class="container mx-auto px-4">
        <div class="flex flex-col md:flex-row justify-between items-center gap-4">
          <p class="text-white/60 text-sm">
            © {{ new Date().getFullYear() }} UNAC national. Tous droits réservés.
          </p>
          <div class="flex items-center gap-4">
            <template v-for="(socialLink, index) in socialLinks" :key="`footer-social-${index}`">
              <a :href="socialLink.url" target="_blank" rel="noopener"
                class="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-white hover:bg-primary hover:text-white transition-all duration-300">
                <svg v-if="socialLink.network === 'facebook'" class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
                </svg>
                <svg v-else class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                </svg>
              </a>
            </template>
            <a v-if="displayWhatsapp" :href="authStore.isAuthenticated ? displayWhatsapp.url : '#'" target="_blank" rel="noopener" :class="[
              'w-10 h-10 rounded-xl flex items-center justify-center text-white transition-all duration-300',
              authStore.isAuthenticated
                ? 'bg-primary/10 hover:bg-primary hover:text-white cursor-pointer'
                : 'bg-gray-400 cursor-not-allowed'
            ]" :title="authStore.isAuthenticated ? 'Contacter via WhatsApp' : 'Réservé aux adhérents'">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <ContactPopup v-model="OpenContactModal" />
  <LoginPopup v-model="OpenModal" />
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useAuthStore } from '../stores/auth'
import { useFrontSettingsStore } from '../stores/front_settings'
import ContactPopup from './ContactPopup.vue'
import LoginPopup from './LoginPopup.vue'
import logo from '../../assets/images/svg/logo-dark.svg'
const authStore = useAuthStore()
const frontSettingsStore = useFrontSettingsStore()
const OpenModal = ref(false)
const OpenContactModal = ref(false)

const companyID = computed(() => {
  return JSON.parse(localStorage.getItem('selectedCompany'))?.id || 1;
})

const selectedCompany = computed(() => {
  return JSON.parse(localStorage.getItem('selectedCompany'))
})

const contactInfo = computed(() => frontSettingsStore.getContactInfo)
const whatsappInfo = computed(() => frontSettingsStore.getWhatsapp)
const socialMedia = computed(() => frontSettingsStore.getSocialMedia)

const companyPhone = computed(() => {
  const companyId = JSON.parse(localStorage.getItem('selectedCompany'))?.id || 1;
  if (companyId == 1) {
    return {
      phone1: '0141564076',
      phone2: '0141564077',
    }
  }
  return null
})

const fallbackEmail = computed(() => selectedCompany.value?.name === 'EasyJet' ? 'easyjet@unac.asso.fr' : 'navigants@unac.asso.fr')

const displayEmail = computed(() => contactInfo.value?.email || fallbackEmail.value)

const displayAddressLines = computed(() => {
  const address = contactInfo.value?.address || 'UNAC Cité PN\nBureau 2D045 - 2e étage'
  return address.split(/\r?\n|<br\s*\/?>/i).map((line) => line.trim()).filter(Boolean)
})

const displayPhones = computed(() => {
  const phones = []
  if (contactInfo.value?.firstPhone) {
    phones.push({ label: 'Tél 1', value: contactInfo.value.firstPhone })
  }
  if (contactInfo.value?.secondPhone) {
    phones.push({ label: 'Tél 2', value: contactInfo.value.secondPhone })
  }
  if (phones.length) return phones
  if (companyPhone.value) {
    return [
      { label: 'Tél 1', value: companyPhone.value.phone1 },
      { label: 'Tél 2', value: companyPhone.value.phone2 },
    ]
  }
  return []
})

const displayWhatsapp = computed(() => {
  if (!whatsappInfo.value?.phone || !whatsappInfo.value?.url) return null
  return {
    label: whatsappInfo.value.label || 'WhatsApp',
    value: whatsappInfo.value.phone,
    url: whatsappInfo.value.url
  }
})

const socialLinks = computed(() => {
  const links = []
  const pushLink = (network, account) => {
    if (!account?.url) return
    links.push({
      network,
      label: account.label || account.url,
      url: account.url
    })
  }

  pushLink('facebook', socialMedia.value?.facebook?.primary)
  pushLink('facebook', socialMedia.value?.facebook?.secondary)
  pushLink('instagram', socialMedia.value?.instagram?.primary)
  pushLink('instagram', socialMedia.value?.instagram?.secondary)

  if (links.length) return links

  if (companyID.value === 1) {
    return [
      { network: 'facebook', label: 'UNAC Air France Facebook', url: 'https://www.facebook.com/groups/3031498563680006' },
      { network: 'instagram', label: '@unac.airfrance', url: 'https://www.instagram.com/unac.airfrance' }
    ]
  }
  if (companyID.value === 2) {
    return [
      { network: 'facebook', label: 'UNAC EZY Adhérents', url: 'https://www.facebook.com/groups/unacezyadherents' }
    ]
  }
  return []
})

onMounted(async () => {
  try {
    await frontSettingsStore.fetchSettings(companyID.value)
  } catch (error) {
    console.error('Error loading front settings:', error)
  }
})

</script>

<style scoped>
.bg-primary-dark {
  background-color: rgba(0, 0, 0, 0.2);
}
</style>
